import { render, staticRenderFns } from "./FormTipoProducto.vue?vue&type=template&id=290b9bee&"
import script from "./FormTipoProducto.vue?vue&type=script&lang=js&"
export * from "./FormTipoProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports